import React, { useState, useContext, } from 'react';
import {Form, Input, Select, Row, Checkbox, Typography, message, Col, Space, } from 'antd';
import TextArea from 'antd/lib/input/TextArea';
import { arrStates } from '../../Modals/AddNewStationModal.component';
import { isValidPhoneNumber, maskPhoneNumber, validatePhoneNumber, isValidOracleID, isValidContractNumber, } from '../../../../Validation';
import { StationContext } from '../../../../context/station-context';
import { updateStationInformation } from '../../../../services/StationService';
import { findUniqueStation } from '../../../../services/MainService';

const { Item } = Form;
const { Option } = Select;
const { Text } = Typography;

export const EditStationInformationForm = ({ form, ...props }) => {
    
    const [state, dispatch] = useContext(StationContext);
    const station = state.station;

    const [phoneAlerts, setPhoneAlerts] = useState(station.enablePhoneAlerts);
    const [emailAlerts, setEmailAlerts] = useState(station.enableEmailAlerts);

    const onFinish = (values) => {
        Object.assign(values, {id: station.id})
        updateStationInformation(values).then((response) => {
            if (response.result){
                dispatch({
                    type: 'UPDATE_STATION_INFORMATION', 
                    payload: {...values},
                })

                findUniqueStation({id: station.id}).then( function ( response ){
                    if( response ) {
                        message.success(<span>Station <Text strong>{response.name}</Text> has been updated!</span>);
                        dispatch({
                            type: "SET_STATION",
                            payload: response,
                        });
                    }
                })
            }
        })
    };

    return(
        <>  
            <div className={`station-information-form`} {...props} >  
                <Form 
                    autoComplete='off'
                    form={form}
                    id={`station-${station.id}-information-form`}
                    preserve={false}
                    initialValues={station}
                    layout='vertical'
                    onFinish={(values) => onFinish(values)}
                    >
                    <Row gutter={16}>
                        <Col span={8}>
                            <Item label='Name:' name='name' >
                                <Input type='text'/>
                            </Item>
                        </Col>
                        <Col span={8}>
                            <Item label='Oracle ID:' name='oracleID' tooltip='Oracle ID numbers are 5-6 digits' hasFeedback
                                rules={[
                                    {
                                        required: false, 
                                        message: 'Oracle ID Numbers must be 5-6 digits'
                                    }, 
                                    { 
                                        validator: (rule, value) => {
                                        
                                            if(!rule.required && !value){
                                                return Promise.resolve()
                                            }

                                            if (value && isValidOracleID(value)){
                                                return Promise.resolve();
                                            }
                                            return Promise.reject(new Error('Oracle ID Numbers must be 5-6 digits'));
                                        }
                                    }
                                ]}>
                                <Input type='number' className='no-spinner' min='0' />
                            </Item>
                        </Col>
                        <Col span={8}>
                            <Item label='Contract Number:' name='contractNumber' hasFeedback tooltip='Maximum 30 alphanumeric characters'                         
                                rules={[
                                    {
                                        required: false, 
                                        message: 'Please enter maximum 30 alphanumeric characters.',
                                        validator: (rule, value) => {
                                            if(!rule.required && !value){
                                                    return Promise.resolve();
                                                }

                                            if (value && isValidContractNumber(value)) {
                                                return Promise.resolve();
                                                }
                                            return Promise.reject(new Error('Please enter maximum 30 alphanumeric characters.'));
                                        }
                                    }
                                ]}
                            >
                                <Input type='text' showCount />
                            </Item>
                        </Col>
                    </Row>
                    <Row gutter={16}>
                        <Col xs={24} sm={24} md={24} lg={8} xl={12}>
                            <Item 
                                label=" Street Address:" 
                                name="streetAddress"
                                rules={[
                                    { 
                                        max: 45, 
                                        message: 'Street address cannot be longer than 45 characters'
                                    }
                                ]}
                                >
                                <Input maxLength={45} showCount/>
                            </Item>
                        </Col>
                        <Col xs={24} sm={24} md={8} lg={6} xl={4}>
                            <Item 
                                label='City:' 
                                name='city'
                                rules={[
                                    { 
                                        max: 45, 
                                        message: 'City cannot be longer than 45 characters'
                                    }
                                ]}
                                >
                                <Input maxLength={45}/>
                            </Item>
                        </Col>
                        <Col xs={24} sm={24} md={8} lg={6} xl={4}>
                            <Item label='State:' name='state'>
                                <Select placeholder='Select State' showSearch>
                                {
                                    arrStates.map((item) => {
                                        return <Option key={item.abbreviation} value={item.abbreviation}>{item.abbreviation}</Option>
                                    })
                                }
                                </Select>
                            </Item>
                        </Col>
                        <Col xs={24} sm={24} md={8} lg={4} xl={4}>
                            <Item label='Zip Code:' name='zip'>
                                <Input/>
                            </Item>
                        </Col>
                    </Row>

                    <Row gutter={16}>
                        <Col xs={24} sm={24} md={24} lg={12} xl={12}>
                            <Item 
                                label="Email Address:" 
                                name="email" 
                                tooltip={emailAlerts ? 'Required when you enable email alerts' : ''}
                                style={{flexBasis: 300}}
                                rules={[
                                    {
                                        required: emailAlerts, 
                                        type: 'email',
                                        message: 'Invalid email address. Ex: user@avalan.com'
                                    }
                                ]}
                                >
                                <Input/>
                            </Item>
                        </Col>
                        <Col xs={24} sm={24} md={16} lg={8} xl={8}>
                            <Form.Item 
                                label='Phone Number:' 
                                name='phone' 
                                hasFeedback
                                validateTrigger='onChange'        
                                rules={[
                                    {
                                        required: phoneAlerts,
                                        message: 'Phone number is required.',
                                    },
                                    {
                                        validator: (rule, value) => {
                                            
                                            if(!rule.required && !value){
                                                return Promise.resolve();
                                            }

                                            if (value && validatePhoneNumber(value) && isValidPhoneNumber(value)) {
                                                return Promise.resolve();
                                            }
                                            
                                            return Promise.reject(new Error('Enter valid phone number.'));
                                            }
                                        },
                                    ]}     
                                >
                                <Input className='no-spinner' onInput={e => maskPhoneNumber(e)}/>
                            </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={8} lg={4} xl={4}>
                            <Item 
                                label="Phone Carrier:" 
                                name="phoneCarrier" 
                                rules={[
                                    {
                                        required: phoneAlerts, 
                                        message: 'Please select a Phone Carrier'
                                    }
                                ]}
                                >
                                <Select placeholder="Please choose one">
                                    <Option value="AT&T">AT&T</Option>
                                    <Option value="Google-Fi">Google-Fi</Option>
                                    <Option value="Sprint">Sprint</Option>
                                    <Option value="T-Mobile">T-Mobile</Option>
                                    <Option value="Verizon">Verizon</Option>
                                </Select>
                            </Item>
                        </Col>
                    </Row>

                    <Space direction='vertical'>
                        <Text strong>Alert Preferences</Text>
                        <Space>
                            <Item name='enableEmailAlerts' valuePropName='checked'>
                                <Checkbox onChange={(e) => setEmailAlerts(e.target.checked)}>
                                    Email Alerts
                                </Checkbox>
                            </Item>
                            <Item name='enablePhoneAlerts' valuePropName='checked'>
                                <Checkbox onChange={(e) => setPhoneAlerts(e.target.checked)}>
                                    Phone Alerts
                                </Checkbox>
                            </Item>
                        </Space>
                    </Space>

                    <Item label={<Text>Comments <span className='text-secondary'>(Optional)</span>:</Text>} name="comment" style={{width: '100%'}}>
                        <TextArea showCount maxLength={255} autoSize={{minRows: 2, maxRows: 3}}/>
                    </Item>
                </Form>
            </div>  
        </>
    );
};